module.exports = __webpack_public_path__ + "img/swiper_2.adb03e19.png";